import React, { type FC } from "react";
import { shallowEqual } from "react-redux";
import { formatPriceIntl } from "../../../../../../../common-deprecated/priceUtils";
import Text from "../../../../../shared-components/css-modules/lexus/atoms/Text";
import { useGradeSelectorSelector } from "../../../../redux/hooks";
import { GradeSelectorMemoLabel } from "../../../../utils/labels";
import { useCommonSelector } from "../../../../../../../common-deprecated/redux/commonStore";
import { dualCurrencyDisclaimerSelector } from "../../../../../../../shared-logic/utils/dualCurrencyDisclaimerUtils";
import styles from "./ExchangeRate.module.scss";
import Popover from "../../../../../shared-components/css-modules/lexus/vendor/popover/Popover";
import Button from "../../../../../shared-components/css-modules/lexus/atoms/Button";
import Icon from "../../../../../shared-components/css-modules/lexus/atoms/Icon";
import { limitFractionDigits } from "../../../../../../../shared-logic/utils/priceUtils";

const ExchangeRate: FC = () => {
    const commonSettings = useGradeSelectorSelector((state) => state.commonSettings);
    const dualCurrencyDisclaimer = useCommonSelector(dualCurrencyDisclaimerSelector, shallowEqual);

    if (!commonSettings.currencyMultiplier) {
        return null;
    }

    const { primaryPrice, secondaryPrice } = formatPriceIntl(
        commonSettings,
        1,
        { currencyDisplay: "code" },
        true,
        undefined,
        // as secondary value is not really a price that needs to take in
        // account maximumFractionDigits from commonSettings, we set it to max
        20,
        commonSettings.reverseCurrencyMultiplier,
    );

    return (
        <Text tag="div" variant="apheleia-body" color="grey-7">
            <div className={styles["exchange-rate"]}>
                <GradeSelectorMemoLabel
                    label="gradeSelectorExchangeRate"
                    params={{
                        primaryPrice: limitFractionDigits(primaryPrice, 2),
                        secondaryPrice: limitFractionDigits(secondaryPrice || "0", 2),
                    }}
                />
                {dualCurrencyDisclaimer && (
                    <Popover>
                        <Popover.Trigger>
                            <Button variant="clean" type="button">
                                <Icon variant="info" sizing="md" aria-hidden="true" />
                            </Button>
                        </Popover.Trigger>
                        <Popover.Content>{dualCurrencyDisclaimer}</Popover.Content>
                    </Popover>
                )}
            </div>
        </Text>
    );
};

export default ExchangeRate;
